import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HomePage, TrainingPage, AITrainingPage, PromptCrafterPage } from './pages';
import Bhole from './components/Bhole';
import { useDocumentMeta, trackPageView, Navbar } from './shared';

const HIDE_NAVBAR_ROUTES = ['/training', '/ai-training'];

function AppContent() {
  useDocumentMeta();

  const location = useLocation();
  useEffect(() => {
    trackPageView(document.title, location.pathname);
  }, [location.pathname]);

  const hideNavbar = HIDE_NAVBAR_ROUTES.includes(location.pathname);

  return (
    <>
      {!hideNavbar && <Navbar />}
      <main className={hideNavbar ? '' : 'with-navbar'}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="bhole" element={<Bhole />} />
          <Route path="training" element={<TrainingPage />} />
          <Route path="ai-training" element={<AITrainingPage />} />
          <Route path="prompt-crafter" element={<PromptCrafterPage />} />
        </Routes>
      </main>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
